/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../../../fc_link/fc_link';
import Poster from '../../../poster/poster';
import TagPoster from '../../../poster/tag_poster';
import Eyebrow from '../../../eyebrow/eyebrow';
import { isAdvertorial, isPremium } from '../../../advertorial/advertorial';
import BrandworksAnimation from '../brandworks_animation/brandworks_animation';

class DefaultCard extends React.Component {
  constructor(props) {
    super(props);

    const { tags, allowTextOnly } = this.props.metadata;

    this.textOnlyCard =
      allowTextOnly && !get(this.props.metadata, 'featured_image.source');

    this.advertorial = isAdvertorial(tags) && !this.props.fullPageAdvertorial;
    this.isPremiumArticle = isPremium(tags);

    this.setCardClasses = this.setCardClasses.bind(this);
    this.setPosterClasses = this.setPosterClasses.bind(this);
    this.setTextWrapperClass = this.setTextWrapperClass.bind(this);
  }

  setCardClasses() {
    const { events } = this.props.metadata;
    const classNames = ['card', 'card--default'];

    if (this.props.noBottomBorder) {
      classNames.push('card--noBottomBorder');
    }

    if (this.props.top) {
      classNames.push('card--top');
    }

    if (this.textOnlyCard) {
      classNames.push('card--text');

      if (this.props.totalCards) {
        classNames.push(`card--size-${this.props.totalCards}`);
      }
    }

    if (events) {
      classNames.push('card--event');
    }

    if (this.advertorial || get(this.props.metadata, 'isSponsoredTile')) {
      classNames.push('card--advertorial');
    }

    return classNames.join(' ');
  }

  setPosterClasses() {
    const { hasVideoPoster } = this.props.metadata;

    const posterClasses = ['card__poster', 'card__poster--default'];

    if (hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  }

  setTextWrapperClass() {
    const event = get(this.props.metadata, 'events');
    const textWrapperClasses = ['card__text-wrapper'];

    if (!event) {
      textWrapperClasses.push('card__text-wrapper--default');
      if (this.props.align) {
        textWrapperClasses.push(
          `card__text-wrapper--align-${this.props.align}`
        );
      }
    }

    if (this.textOnlyCard) {
      textWrapperClasses.push('card__text-wrapper--text-only');
    } else if (!this.advertorial && !event) {
      textWrapperClasses.push('card__text-wrapper--border-bottom');
    }

    return textWrapperClasses.join(' ');
  }

  render() {
    const { cardType } = this.props.metadata;
    const { dianomiRow } = this.props;
    return (
      <article
        className={this.setCardClasses()}
        onClick={event => this.props.cardEvent(event)}
      >
        <FCLink
          to={get(this.props.metadata, 'link')}
          title={get(this.props.metadata, 'title')}
          config={this.props.config}
          metadata={this.props.metadata}
          cardType={cardType}
          externalLink={
            get(this.props.metadata, 'external') ||
            get(this.props.metadata, 'source') === 'external'
          }
          targetWindow={get(this.props.metadata, 'targetWindow')}
        >
          {this.props.posterType && this.props.posterType === 'tag' ? (
            <TagPoster
              metadata={this.props.metadata}
              className={this.setPosterClasses()}
              generateClasses={false}
            />
          ) : (
            <Poster
              metadata={this.props.metadata}
              className={this.setPosterClasses()}
              generateClasses={false}
            />
          )}
          <div className={this.setTextWrapperClass()}>
            {!dianomiRow && cardType === 'Sponsored Story' ? (
              <div>
                <div className="brandworks-logo-desktop">
                  <BrandworksAnimation />
                </div>
                <div className="brandworks-logo-mobile" />
              </div>
            ) : null}
            <Eyebrow
              metadata={this.props.metadata}
              showIcon={this.isPremiumArticle}
            />
            <h2
              className={`card__title card__title--default ${
                this.textOnlyCard ? 'card__title--only' : ''
              } ${
                cardType === 'Sponsored Story' ? 'card__title--sponsored' : ''
              }`}
            >
              {get(this.props.metadata, 'title')}
            </h2>
            {get(this.props.metadata, 'events') ? (
              <button className="card__button">
                {get(this.props.metadata, 'buttonText')}
              </button>
            ) : (
              ''
            )}
          </div>
        </FCLink>
      </article>
    );
  }
}

DefaultCard.defaultProps = {
  cardEvent: () => {},
  fullPageAdvertorial: false,
  totalCards: 0,
  noBottomBorder: false,
  align: null,
  top: false,
  posterType: 'default'
};

DefaultCard.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  fullPageAdvertorial: PropTypes.bool,
  cardEvent: PropTypes.func,
  totalCards: PropTypes.number,
  noBottomBorder: PropTypes.bool,
  align: PropTypes.string,
  top: PropTypes.bool,
  posterType: PropTypes.string
};

export default DefaultCard;
